import * as actions from '../../actions/actionTypes';
import initialState from '../initialState';

/**
 * This reducer handles the LOAD_MASTER_DATA_MANAGEMENT_DATA_SUCCESS & LOAD_MASTER_DATA_MANAGEMENT_DATA_FAILURE action and sets bulk process management grid data to the store
 * @param {Object} [state] The master data management grid data
 * @param {Object} action The action to be handled
 * @returns {Object} The master data management grid data
 */

export default function masterDataManagementReducers(state = initialState.groupsData, action) {
    if (action.type == actions.LOAD_MASTER_DATA_MANAGEMENT_DATA_SUCCESS && Array.isArray(action.groupsData)) {
        return action.groupsData;
    } else if (action.type == actions.LOAD_MASTER_DATA_MANAGEMENT_DATA_FAILURE) {
        return initialState.groupsData;
    } else {
        return state;
    }   
}
